__turbopack_context__.v({
  "className": "pixelify_sans_198627cb-module__As0J0W__className",
});
